exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".user-selects-group-wpr{position:relative}.user-selects-group-wpr .group-btn,.user-selects-group-wpr .save-to-group{position:absolute;right:60px;top:13px;z-index:2;font-size:12px;color:#ddd;cursor:pointer}.user-selects-group-wpr .group-btn:hover,.user-selects-group-wpr .save-to-group:hover{color:#20a0ff}.user-selects-group-wpr .save-to-group{right:35px}.group-info{color:red;position:absolute;top:40px;width:100%;z-index:10000;box-shadow:1px 1px 1px #ddd}.group-info .el-table tr{cursor:pointer}.group-info .el-table tr td,.group-info .el-table tr th{height:34px}.group-info .el-table tr td .cell,.group-info .el-table tr th .cell{border-right:none;border-left:none;text-align:left}.group-info .el-tag{margin:5px 5px 5px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e888f0a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/userSelect/userSelect.vue
// module id = 844
// module chunks = 23